'use client';

import { motion } from 'framer-motion';

export const MotionP = motion.p;
